import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesTall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-tall"><path fillRule="evenodd" clipRule="evenodd" d="M4.75 2C4.33579 2 4 2.33579 4 2.75V17.25C4 17.6642 4.33579 18 4.75 18H8V21.25C8 21.6642 8.33579 22 8.75 22H19.25C19.6642 22 20 21.6642 20 21.25V6.75C20 6.33579 19.6642 6 19.25 6H16V2.75C16 2.33579 15.6642 2 15.25 2H4.75ZM8.75 6H14.5V3.5H5.5V16.5H8V6.75C8 6.33579 8.33579 6 8.75 6Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSlidesTall;
